(function () {
  function toArray(list) {
    return Array.prototype.slice.call(list);
  }

  function init(root) {
    if (!root || root.getAttribute('data-dx-ready') === 'true') return;

    var thumbs = toArray(root.querySelectorAll('[data-dx-thumb]'));
    var images = toArray(root.querySelectorAll('[data-dx-img]'));
    if (thumbs.length === 0 || images.length === 0) return;

    root.setAttribute('data-dx-ready', 'true');

    function show(index) {
      images.forEach(function (img, i) {
        var on = i === index;
        img.classList.toggle('is-active', on);
        if (on) img.removeAttribute('hidden');
        else img.setAttribute('hidden', '');
      });
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === index);
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = parseInt(thumb.getAttribute('data-index'), 10) || 0;
        show(index);
      });
    });
  }

  function boot() {
    toArray(document.querySelectorAll('[data-dx]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    toArray(event.target.querySelectorAll('[data-dx]')).forEach(function (el) {
      el.removeAttribute('data-dx-ready');
      init(el);
    });
  });
})();
